import React from 'react'
import {t, Trans} from '@lingui/macro'

import {typePaginationDashboardObject} from '../DashboardContentTable/PaginationDashboard/PaginationDashboard';

import {DataTableDashboard} from '../DashboardContentTable/DataTableDashboard';
import {TableBody, TableHeader} from './tableData';
import {PopupPanelDashboard} from '../DashboardContentTable/PopupPanelDashboard';

import {DashboardContentPage} from '../DashboardContentTable';

import {FiltersDashboard} from "../DashboardContentTable/FiltersDashboard";

import {InputSearch} from "../../../UI/InputSearch/InputSearch";
import { IdCashDesksStateDataItem } from 'model/dashboardCashDesks/dCashDesksReducer';
import { DCashDesksFilters } from 'components/containers/dashboard/dataCashDesk/filters';
import { PopupDetails } from 'components/containers/dashboard/dataCashDesk/popupContents/popupDetails';



export type typeViewDataCashDesks = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>

    openFilterBar: boolean
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>

    openPopupDetails: boolean
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>


    searchValue: string
    onChangeSearchValue: (e: (React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>)) => void
    onEnterSearch: () => void
    onClearSearch: () => void

    currentItem: IdCashDesksStateDataItem | undefined
    pagination?: typePaginationDashboardObject
    isActiveFilters: boolean
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}

export const ViewDataCashDesks: React.FC<typeViewDataCashDesks> = (
    {
        variant,
        setSidebarOpen,
        openFilterBar, setOpenFilterBar,
        openPopupDetails, setOpenPopupDetails,

        searchValue,  onChangeSearchValue,
        onClearSearch,  onEnterSearch,

        pagination,
        isActiveFilters, setIsActiveFilters

    }) => {

    return (
        <DashboardContentPage
            headerTitle={<Trans>Cashier-Desk Management</Trans>}
            setSidebarOpen={setSidebarOpen}

        >
            {/* Filter bar */}
            <FiltersDashboard
                variant={variant}
                filters={{
                    filtersForm: <DCashDesksFilters setOpenFilterBar={setOpenFilterBar}  setIsActiveFilters={ setIsActiveFilters }/>,
                    openFilterBar: openFilterBar,
                    setOpenFilterBar: setOpenFilterBar,
                }}
                searchBar={<InputSearch
                    id="posSearch"
                    name="posSearch"
                    placeholder={ t`Search by store's name` }
                    value={searchValue}
                    onChange={onChangeSearchValue}
                    onClear={onClearSearch}
                    onKeyEnterDown={onEnterSearch}
                />}
                isActiveFilters={ isActiveFilters }
            />

            {/* Table data */}
            <DataTableDashboard
                tableHeader={<TableHeader />}
                tableBody={<TableBody  setOpenPopupDetails={setOpenPopupDetails}/>}
                pagination={pagination}
            />

            {/* Popup Details CashDesks dialog */}
            <PopupPanelDashboard
                title={<Trans>Details</Trans>}
                openPopup={openPopupDetails}
                setOpenPopup={setOpenPopupDetails}
            >
                <PopupDetails setOpenPopup={setOpenPopupDetails}/>
            </PopupPanelDashboard>


        </DashboardContentPage>
    )
}
